import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { decamelize } from '../../utils/keysConverter';

export default {
  create(params) {
    const url = formUrl('/api/v1/admin/cashbacks/multiple_cashback');

    return FetchHelpers.post(url, decamelize(params));
  },
};
